import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCreditCard, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import mainAxios from '../../services/mainAxios';
import Subscriptions from '../Companies/Subscriptions/Subscriptions';
import Loader from '../Layout/Loader';
import useSettingsCompany from './useSettingsCompany';
import SettingsBreadcrumb from './SettingsBreadcrumb';
import './settings.scss';

const SubscriptionSettings = () => {
  const { t } = useTranslation('translations');
  const {
    company,
    setCompany,
    getCompany,
    loading,
    isAdminMode,
    getBackUrl,
    user,
    selectedCompany,
  } = useSettingsCompany();

  const [pageLoading, setPageLoading] = useState(false);

  const editCompany = ({ newCompany } = {}) => {
    return mainAxios
      .post('apiEndpoint/saveOrUpdate', {
        object: 'Company',
        content: newCompany ?? {
          ...company,
        },
        nuis: user.companiesRights.find(
          (c) => c.id === parseInt(selectedCompany)
        )?.nuis,
      })
      .then((res) => {
        if (res?.data?.status === true) {
          return true;
        }
        return false;
      })
      .catch(() => {
        return false;
      });
  };

  const handleCompanyInputs = (e, selectKey, selectValue) => {
    const key = e ? e.target.name : selectKey;
    const value = e ? e.target.value : selectValue;
    let content = { ...company, [key]: value };
    setCompany(content);
    return content;
  };

  if (loading || pageLoading || !company) {
    return <Loader />;
  }

  return (
    <div className="settings-subpage">
      <SettingsBreadcrumb
        items={[{ label: t('navbar.subscriptions') }]}
        company={company}
        isAdminMode={isAdminMode}
      />

      <div className="settings-subpage__header">
        <Link to={getBackUrl()} className="settings-subpage__back-btn">
          <FontAwesomeIcon icon={faArrowLeft} />
        </Link>
        <h2 className="settings-subpage__title">
          <span className="settings-subpage__icon">
            <FontAwesomeIcon icon={faCreditCard} />
          </span>
          {t('navbar.subscriptions')}
        </h2>
        {company && (
          <span className="settings-subpage__company-badge">
            {company.name}
          </span>
        )}
      </div>

      <Subscriptions
        handleCompanyInputs={handleCompanyInputs}
        editCompany={editCompany}
        company={company}
        getCompany={getCompany}
        setCompany={setCompany}
      />
    </div>
  );
};

export default SubscriptionSettings;
